import { toString } from 'lodash-es';
import { googleAnalyticsLib } from 'freedom-shared';
import type { ProductsState } from '@aviata/products-fns';
import type { PassengersAncillaryState } from '@aviata/ancillary-fns';

import type { SelectedSeatsState } from '@/widgets/seat-map';

import type { productsTypes } from '@/entities/products';

import { extractAnalyticsDataLib } from '../analytics-data-extraction';

type BookingSuccessInfo = {
  orderNumber: string;
  packageInfo: productsTypes.ExtendedPackageInfo | null;
  products: ProductsState | null;
  seatMap: SelectedSeatsState | null;
  baggage: Partial<PassengersAncillaryState>;
};

export const bookingSuccess = (info: BookingSuccessInfo) => {
  const packageInfo = extractAnalyticsDataLib.package(
    info.packageInfo,
    info.products,
  );

  googleAnalyticsLib.sendEvent('avfree_success_booking', {
    orderNumber: info.orderNumber,
    products: toString(extractAnalyticsDataLib.products(info.products)),
    packageType: packageInfo?.type,
    packageProducts: packageInfo?.products,
    seatMap: toString(extractAnalyticsDataLib.seatsCodes(info.seatMap)),
    baggage: toString(extractAnalyticsDataLib.baggageCount(info.baggage)),
  });
};
export const bookingError = (error: string) =>
  googleAnalyticsLib.sendEvent('avfree_error_booking', { error });
